import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
//MUI
import { Checkbox, Grid, Stack, Backdrop, Button, Chip, CircularProgress, Typography,Box } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { theme } from '../../assets/themes';
import UButton from "../../components/mui/UButton";
import UAuthButton from "../../components/mui/UAuthButton";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UPopupForm from "../../components/mui/UPopupForm";
import UTable from "../../components/mui/UTable";
import UTextField from "../../components/mui/UTextField";
import USelectBox from "../../components/mui/USelectBox";

import { API, } from "../../config";
import { fni18n, bytesToSize } from "../../services/commonService";
import {
    getAPI
    ,postAPI
    ,putAPI
    ,deleteAPI
} from "../../services/commonService";
import { FileService } from "../../services/FileService";
import BranchModify from "./BranchModify";
import AuthenticationService from "../auth/AuthenticationService.js";
const useYn = [
    {cd: "Y", name: "Y"},
    {cd: "N", name: "N"},
];
export default function BranchPage(){
	const { t } = useTranslation();
    const isUserId = AuthenticationService.getLoggedInUserID();
    const columns = [
        { 
            field: 'id',
            headerName: '번호',
            hide: true,
        },
        {
            field: 'branchCd',
            headerName: '지점',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'branchNm',
            headerName: '지점명',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'bizTyNm',
            headerName: '고객사',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'rgnTyNm',
            headerName: '권역',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'useYn',
            headerName: '사용여부',
            align: "center",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if(params.value=="Y"){
                    return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
                }else {
                    return <Checkbox checked={false} disabled/>
                }
            }
        },
        {
            field: 'regId',
            headerName: '등록자',
            headerAlign: 'center',
            align: 'center',
        },        
        {
            field: 'regDt',
            headerName: '등록일',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'button',
            headerName: '설정',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) =>
            (
                <UButton
                variant="outlined"
                onButtonClick={()=>handleRowSelect(params.rows)}
                menuFrom={location.pathname}
                >
                    보기
                </UButton>
            ),
        },
        {
            field: "delete",
            headerName: "삭제",
            sortable: false,
            width: 100,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <UButton
                    variant="outlined"
                    onButtonClick={() => handleDeleteOne(params.rows)}
                    menuFrom={location.pathname}
                >
                    삭제
                </UButton>
            ),
        },
    ];

    const location = useLocation();

    const [branchList, setBranchList] = useState([{}]);                 //지점

    const [confirmPopupOpen, setConfirmPopupOpen] = useState(false);    // confirm dialog
    const [errorPopupOpen, setErrorPopupOpen] = useState(false);        // error dialog
    const [errorMsg, setErrorMsg] = useState("");                       // api error message
    const [confirmMsg, setConfirmMsg] = useState("");                   // api error message
    const [confirmEvent, setConfirmEvent] = useState("");
    const [ formOpen, setFormOpen ] = useState(false);

    const [excelFormOpen, setexcelFormOpen ] = useState(false); //엑셀업로드 팝업
    const [selectedFiles, setSelectedFiles] = useState([]);	
    const [backdropOpen, setBackdropOpen] = useState(false);

    const [modify, setModify] = useState({
        branchCd : "",          //지점코드
        branchNm:"",            //지점명
        regId:"",               //등록자
        regDt:"",               //등록일
        chkCreate : false,      //add, modify 여부
        useYn : "Y",           //사용여부
    });
    const [search, setSearch] = useState({
        rgnTy: "ALL",
        bizTy: "ALL",
        branchNm: "",
        useYn: "Y",
    });
    const [retailers, setRetailers] = useState([]);
    const [regions, setRegions] = useState([]);

    //화면 로드 시
    useEffect(() => {
        window.scrollTo(0, 0);
        const getLoadData = async () => {
            try {
            await loadBranchGroup()
            await loadComboBoxBranchGroup()
            await getBranchList();
        } catch (e) {
            console.log(e)
        }
        };
        getLoadData();
    }, []);
    
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {branchGroupTy: "RGN_TY", useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRegions(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    // 지점명 가져오기
    const getBranchList = async() => {
        try{
            let res = await getAPI(API.SYSTEM.BRANCH+'/getList', search);
            // console.log(res);
            let data = res.data.result.map((col,i)=>({
                    id:(i+1),
                    branchCd: col.storeCd,
                    branchNm: col.storeNm,
                    addr: col.addr,
                    bizTyNm: col.bizTyNm,
                    rgnTyNm: col.rgnTyNm,
                    bizTy: col.bizTy,
                    rgnTy: col.rgnTy,
                    useYn: col.useYn,
                    regId: col.insId,
                    regDt: col.insDs.substr(0,4) + "-" + col.insDs.substr(4,2) + "-" + col.insDs.substr(6,2) + " " + col.insDs.substr(8,2) + ":" + col.insDs.substr(10,2) + ":" + col.insDs.substr(12,2),
                })
            );            
            setBranchList(data);
        }catch(e){
            console.log("[BranchPage.jsx] getList() Exception: "+e.message);
        }
    };
    
    const handleConfirmOpen = (e) => {
        setConfirmPopupOpen(true);
        setConfirmEvent(e)
    };

    const handleConfirmClose = () => {
        setConfirmPopupOpen(false);
    };

    const handleExcelFormOpen = () => {
        setexcelFormOpen(true);
    };      
    const handleExcelFormClose = () => {
        setexcelFormOpen(false);
    };

    /**처리성공 시 팝업 띄우지 않는다. 실패 시에만 팝업 띄운다 */
    /**처리실패 시에는 창 닫지 않는다. 성공 시에만 자동 closed.*/
    const handelConfirmEvent = async () => {
        try{
            if(confirmEvent==="put"){
                await putAPI(API.SYSTEM.BRANCH, modify).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }else if(confirmEvent==="post"){
                await postAPI(API.SYSTEM.BRANCH, modify).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }else if(confirmEvent==="delete"){
                await deleteAPI(API.SYSTEM.BRANCH, modify).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }
        }catch (error) {
            console.log(error)
        } finally {
            handleConfirmClose();
            await getBranchList();
        }
    };

    const handleErrorOpen = () => {
        setErrorPopupOpen(true);
    };
    const handleErrorClose = () => {
        setErrorPopupOpen(false);
    };

    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
    };
    //검색조건 값 변경되었을 때
    const onSearchChange = async (e) => {
        const {name, value} = e.target;
        setSearch({
            ...search,
            [name]: value,
        });
    };

    //Modify Btn click
    const handleRowSelect = (row) => {        
        handleFormOpen();   //상세팝업
    }

    //Table row Selected handler
    const onSelectedRows = (e, row) => {
        // console.log("Selected Handler");
        // console.log(row);
        setModify({
            branchCd: row.branchCd,
            branchNm: row.branchNm,
            addr: row.addr,
            rgnTy: row.rgnTy,
            bizTy: row.bizTy,
            regDt: row.regDt,
            regId: row.regId,
            useYn: row.useYn,
            chkCreate: row.branchCd?true:false,
        });
    };

    //value 속성으로만 값을 컨트롤 할 수 있어서 
    //onChange를 써서 element를 수정할 수 있는 상태로 만듦
    const onModifyChange = (e) => {
        const { name, value } = e.target;
        setModify({
            ...modify,
            [name]: value,
        });
    };
    const onCheckboxChange = (e) => {
        setModify({
          ...modify,
          [e.target.name]: e.target.checked === true ? "Y" : "N",
        });
    };
    
    async function onButtonClick(dvsn){
        if(dvsn==="추가"){
            
            const now = new Date().toISOString().slice(0, 10).replace(/-/g,"");
            const today = new Date();
            const hours = today.getHours() < 10 ? "0"+today.getHours() : today.getHours(); // 시
            const minutes = today.getMinutes() < 10 ? "0"+today.getMinutes() : today.getMinutes();  // 분
            const seconds = today.getSeconds() < 10 ? "0"+today.getSeconds() : today.getSeconds();  // 초
            const date = now+hours+minutes+seconds;
            // console.log("REG Date = "+date);
            
            setModify({
                branchCd : "",
                branchNm:"",
                regId:isUserId,                
                regDt:date,
                chkCreate : false,
                useYn : "Y",
            });
            handleRowSelect({});
        } else if(dvsn == "업로드"){

            const fileCnt = selectedFiles.length; 
            if(fileCnt<1){
                setErrorMsg("선택된 파일이 없습니다. 파일을 선택해주세요.");//en,kr
                handleErrorOpen();
                return;
            }

            uploadExcelFile();
        
        } else if(dvsn === "조회"){
            getBranchList()
        } else {
            setErrorMsg(t("알 수 없는 오류가 발생하였습니다"))
            handleErrorOpen();
        }
    };
    
    const handleDeleteOne = async(arg) => {

        await deleteAPI(API.SYSTEM.BRANCH, {branchCd:arg.branchCd}).then((res) => {
            if (res.data.code === 200) {
                handleFormClose();
                onButtonClick("조회");
            } else {
                setErrorMsg(t("연결된 데이터가 존재하여 삭제되지 않았습니다."));
                handleErrorOpen();
            }
        });
    };
    const onSave = async (e) => { 
        let flag;
        await getAPI(API.SYSTEM.BRANCH+'/duplicateCheck', modify).then((res) =>{
            flag=res.data;
        });
        // console.log("[API Receive] => "+flag);
        
        //지점코드 미입력
        if(flag==-1){
            setErrorMsg(t("지점번호")+t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        }else if(flag==-2){
            setErrorMsg(t("지점명")+t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        }else if(flag==0){
            setConfirmMsg(t("등록하시겠습니까?"));
            handleConfirmOpen("post");
        }else if(flag>0){
            setConfirmMsg(t("정보를 수정하시겠습니까?")+" "+"["+ modify.branchNm+"]" );
            handleConfirmOpen("put");
        }
    }

    // 엑셀 업로드
    const fnExcelBrowser = () => {
        const element = document.createElement('input');
        element.name = "file";
        element.type = "file";
        element.accept = ".xlsx, .xls, .csv";
        element.multiple = false;
        element.onchange = onSaveFile;
        element.click();
    };

    const handleDelete = (chipToDelete) => () => {
        setSelectedFiles((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
    };
    const onSaveFile = (e) => {
        const uploadFiles = Array.prototype.slice.call(e.target.files); // 파일선택창에서 선택한 파일들
        const _inputData = uploadFiles.map((m,i)=>({
            key: `file-+${i}`,
            label: `${m.name} (${bytesToSize(m.size)})`,
            file: m,
        }));
        setSelectedFiles(_inputData);
    };

    const uploadExcelFile = async() => {
        const fd = new FormData();
        
        Object.values(selectedFiles).forEach((f)=>(
          fd.append("file",f.file)
        ));
        fd.append("page","branch");
            
        try{
            await FileService.files(API.COMMON.UPLOAD_EXCEL,fd).then((res)=>{
                console.log(res);
                if(res.status == '200' && res.data != ""){
                    let message = ""
                    if (res.data.errCode === -1) {
                        message = t(res.data.errMsg);
                    } else {
                        message = t("파일 업로드 데이터 저장") + "\n\n["
                                + t("저장 결과") + "]\n* "
                                + t("전체 개수") + " : " + res.data.total + "\n* "
                                + t("성공 개수") + " : " + res.data.success+ "\n* "
                                + t("실패 개수") + " : " + res.data.fail;
                        if (res.data.fail !== 0)
                            message += " (" + res.data.failNoList.map(n => `No. ${n}`).join(', ') + ")";
                    }
                    setErrorMsg(message);
                    handleErrorOpen();
                    getBranchList();
                    handleExcelFormClose();
                }else{
                    setErrorMsg(t("실패"));
                    handleErrorOpen();
                    handleExcelFormClose();
                }
              });                
        }catch(e){
            // console.log("catch~!!!!!!");
            console.log(e.message);
        }
    }

    return(
    <div className="main-container">
        <div className="header">
            <Grid container>
                <Grid item xs={10}>
                    {/* 상단메뉴명 */}
                    <UBreadCrumbs
                        title={"시스템관리"}
                        subtitle={"지점관리"}
                    />
                </Grid>
                <Grid item xs={2}>
                    {/* 툴바 버튼 */}
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="flex-start"
                        spacing={0.5}
                    >
                    </Stack>
                </Grid>
            </Grid>
            {/* <Divider variant="middle"/> */}
        </div>

        <div className="contents">
            <Box>
                {/* 조회조건 */}
                <TableContainer className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                            <TableRow className="table-row-header">
                                <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                                <TableCell className="table-cell">
                                    {/* <UTextField name="bizTy" onChange={onSearchChange}/> */}
                                    <USelectBox
                                        name="bizTy"
                                        items={retailers}
                                        onItemChange={onSearchChange}
                                    />
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n("권역")}</TableCell>
                                <TableCell className="table-cell">
                                    {/* <UTextField name="rgnTy" onChange={onSearchChange}/> */}
                                    <USelectBox
                                        name="rgnTy"
                                        items={regions}
                                        onItemChange={onSearchChange}
                                    />
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n("지점명")}</TableCell>
                                <TableCell className="table-cell">
                                    <UTextField name="branchNm" onChange={onSearchChange}/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n("사용여부")}</TableCell>
                                <TableCell className="table-cell">
                                    <USelectBox
                                        id="useYn"
                                        name="useYn"
                                        items={useYn}
                                        onItemChange={onSearchChange}
                                        defaultValue={search.useYn}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="search">
                    <UButton icon="Search" onButtonClick={onButtonClick}>
                        조회
                    </UButton>
                </div>
            </Box>
            {/* 조회 리스트 */}
            <UTable 
                columns={columns} 
                rows={branchList}
                onSelectedRowChange={onSelectedRows}
                rowPerPage={10}
                toolbarAdd={
                    <>
                        <UAuthButton 
                            icon="Add" 
                            menuFrom={location.pathname} 
                            onButtonClick={onButtonClick}
                        >
                            추가
                        </UAuthButton>
                        &nbsp;&nbsp;
                        <UAuthButton
                            icon="Upload"
                            onButtonClick={handleExcelFormOpen}
                        >
                            업로드
                        </UAuthButton>
                    </>
                }
            />
        </div>
        <UConfirmDialog
            message={confirmMsg}
            open={confirmPopupOpen}
            onClose={handleConfirmClose}
            onClickOk={handelConfirmEvent}
        />
        <UAlertDialog
            message={errorMsg}
            open={errorPopupOpen}
            onClose={handleErrorClose}
        />
        {/* 팝업 */}
        <UPopupForm
            open={formOpen}
            onClose={handleFormClose}
            onSave={onSave}
            title='지점 설정'
            type={"2"}
            content={<BranchModify data={modify} onParamsChange={onModifyChange} onCheckboxChange={onCheckboxChange} />}
        /> 

        {/* EXCEL UPLOAD */}
        <div>
            <Dialog
                open={excelFormOpen}
                onClose={handleExcelFormClose}
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth="md">
                <DialogTitle style={{ backgroundColor: "#F6F6F6", color:"#2F2F2F", borderBottom: "1px solid #444444", height:"50px", fontSize:"20px"}} id="draggable-dialog-title" onClose={handleExcelFormClose}>
                <Typography>{fni18n('업로드')}</Typography>
                    <IconButton
                    aria-label="close"
                    onClick={handleExcelFormClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}>
                    <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                <DialogContentText>

                {/* Excel 파일업로드  */}              
                <div className="pop-container">
                    <div className="contents">
                    <TableContainer className="table-container">
                        <Table className="table" size="small">
                        <TableBody>
                            <TableRow>
                            <TableCell className="table-cell-title">{fni18n('파일')}</TableCell>
                                <TableCell className="table-cell" colspan={3}>
                                <Button variant='text' color="primary" 
                                    onClick={()=>fnExcelBrowser()}>
                                    {fni18n('파일선택')}
                                </Button>
                                {selectedFiles && selectedFiles.map((data) => {
                                    let icon;
                                    return (
                                        <item key={data.key}>
                                            <Chip
                                            icon={icon}
                                            label={data.label}
                                            onDelete={handleDelete(data)}/>
                                        </item>
                                    );
                                })}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                        </Table>
                    </TableContainer>
                    </div>
                </div>
                {/* END Excel 파일업로드 */}
                </DialogContentText>
                </DialogContent>
                <DialogActions sx={{align: "center", backgroundColor:"#F6F6F6"}}>
                    <UAuthButton variant="contained" color="primary" onButtonClick={onButtonClick}>업로드</UAuthButton>
                    <UButton variant="outlined" onButtonClick={handleExcelFormClose}>닫기</UButton>
                </DialogActions>
                
                <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdropOpen}
                //onClick={handleBackdropClose}
                >
                <CircularProgress color="inherit" />
                </Backdrop>
            </Dialog>
        </div>
    </div>
    );
}